import React from 'react';
import { Grid, Paper } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ISteroidogenesisInhibitorCortisol } from '../../../../../../user/caseDraft/stages/cushing-v2/thirdStage/ThirdStage.types';

interface CortisolDoseChartProps {
  data: ISteroidogenesisInhibitorCortisol[];
  leftLabelName: string;
  rightLabelName: string;
}

const CortisolChart: React.FC<CortisolDoseChartProps> = ({ data, leftLabelName, rightLabelName }) => {
  const validData = data.filter(d => d.date && !isNaN(new Date(d.date).getTime()));

  const sorted = [...validData].sort((a, b) => new Date(a.date!).getTime() - new Date(b.date!).getTime());

  const chartData = sorted.map(d => ({
    dateLabel: d.date
      ? new Date(d.date).toLocaleDateString('pl-PL', {
          year: 'numeric',
          month: 'short'
        })
      : 'Nieznana data',
    cortisol: d.cortisol,
    dose: d.dose
  }));

  return (
    <Grid item xs={12}>
      <Paper elevation={3} style={{ padding: 20 }}>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="dateLabel" />
            <YAxis yAxisId="left" label={{ value: leftLabelName, angle: -90, position: 'insideLeft' }} />
            <YAxis
              yAxisId="right"
              orientation="right"
              label={{ value: rightLabelName, angle: -90, position: 'insideRight' }}
            />
            <Tooltip />
            <Legend />
            <Line yAxisId="left" type="monotone" dataKey="cortisol" stroke="#8884d8" name={leftLabelName} />
            <Line yAxisId="right" type="monotone" dataKey="dose" stroke="#82ca9d" name={rightLabelName} />
          </LineChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default CortisolChart;
